(() => {
  const SELECTOR = '[data-a5-white-story]';
  const cleanups = new WeakMap();

  function mount(root) {
    if (!root || cleanups.has(root)) return;
    const light = root.querySelector('[data-a5-light]');
    const images = [...light.querySelectorAll('[data-a5-frame]')];
    const buttons = [...light.querySelectorAll('[data-a5-stage]')];
    const label = light.querySelector('[data-a5-stage-label]');
    const description = light.querySelector('[data-a5-stage-description]');
    const lightMediaStage = light.querySelector('[data-a5-light-media-stage]');
    const live = light.querySelector('[data-a5-live]');
    const sticky = root.querySelector('[data-a5-sticky]');
    if (!light || !images.length) return;

    const stageNames = ['朝', '昼', '午後', '夕暮れ', '夜', 'ライトアップ'];
    let current = 0;
    let mm;
    let observer;
    let lightObserver;
    let residenceCleanup = () => {};
    let pinTop = 0;

    function measurePinTop() {
      if (!window.matchMedia('(max-width: 899px)').matches) return 0;
      const candidates = [...document.querySelectorAll('sticky-header, .header-wrapper, [data-section-type="header"]')];
      const visibleBottom = candidates.reduce((largest, element) => {
        const rect = element.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0 || rect.top > window.innerHeight * 0.4) return largest;
        return Math.max(largest, rect.bottom);
      }, 0);
      return Math.min(192, Math.max(0, Math.ceil(visibleBottom)) + 24);
    }

    function applyPinTop() {
      pinTop = measurePinTop();
      root.style.setProperty('--a5-pin-top', `${pinTop}px`);
    }

    applyPinTop();

    function mountResidence() {
      const section = root.querySelector('[data-a5-residence]');
      if (!section) return () => {};
      const pin = section.querySelector('.a5-white__residence-pin');
      const media = section.querySelector('[data-a5-residence-media]');
      const copyPanel = section.querySelector('.a5-white__residence-copy');
      const frames = [...section.querySelectorAll('[data-a5-residence-frame]')];
      const angleButtons = [...section.querySelectorAll('[data-a5-residence-angle-button]')];
      const regionButtons = [...section.querySelectorAll('[data-a5-residence-button]')];
      const stageButtons = [...section.querySelectorAll('[data-a5-residence-stage-button]')];
      const residenceLabel = section.querySelector('[data-a5-residence-label]');
      const residenceStageLabel = section.querySelector('[data-a5-residence-stage-label]');
      const residenceMediaAngle = section.querySelector('[data-a5-residence-media-angle]');
      const residenceMediaRegion = section.querySelector('[data-a5-residence-media-region]');
      const residenceMediaStage = section.querySelector('[data-a5-residence-media-stage]');
      const residenceDescription = section.querySelector('[data-a5-residence-description]');
      const residenceLive = section.querySelector('[data-a5-residence-live]');
      if (!pin || !media || angleButtons.length !== 2 || regionButtons.length !== 4 || stageButtons.length !== 6 || frames.length !== 48) return () => {};
      let residenceMM;
      let trigger;
      let timeline;
      let residenceObserver;
      let activeAngle = 'front';
      let activeRegion = 0;
      let activeStage = 0;
      let lastProgress = 0;
      const renderState = { progress: 0 };
      const stageNames = ['夜明け', '朝', '昼', '午後', '夕暮れ', '夜間照明'];
      const holdDuration = 0.62;
      const transitionDuration = 0.82;
      const segments = [];
      const stageStops = [];
      let sequenceDuration = 0;
      for (let stage = 0; stage < 6; stage += 1) {
        const holdStart = sequenceDuration;
        const holdEnd = holdStart + holdDuration;
        segments.push({ type: 'hold', stage, start: holdStart, end: holdEnd });
        stageStops.push((holdStart + holdEnd) / 2);
        sequenceDuration = holdEnd;
        if (stage < 5) {
          segments.push({ type: 'transition', from: stage, to: stage + 1, start: sequenceDuration, end: sequenceDuration + transitionDuration });
          sequenceDuration += transitionDuration;
        }
      }
      stageStops.forEach((value, index) => { stageStops[index] = value / sequenceDuration; });
      const removers = [];
      const selectedFrames = (angle, region) => frames.filter((frame) => frame.dataset.a5ResidenceAngle === angle && Number(frame.dataset.a5ResidenceRegion) === region);
      const findFrame = (angle, region, stage) => frames.find((frame) => frame.dataset.a5ResidenceAngle === angle && Number(frame.dataset.a5ResidenceRegion) === region && Number(frame.dataset.a5ResidenceStage) === stage);
      const angleName = () => angleButtons.find((button) => button.dataset.a5ResidenceAngleButton === activeAngle)?.dataset.a5ResidenceAngleName || '正面';

      const setResidenceActive = (active) => document.documentElement.classList.toggle('a5-white-residence-active', Boolean(active));
      if (window.matchMedia('(max-width: 899px)').matches) {
        const visibleParts = new Set();
        residenceObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRect.height > 1) visibleParts.add(entry.target);
            else visibleParts.delete(entry.target);
          });
          setResidenceActive(visibleParts.size > 0);
        }, { threshold: 0, rootMargin: '-1px 0px -1px' });
        residenceObserver.observe(media);
        if (copyPanel) residenceObserver.observe(copyPanel);
      }
      const updateCopy = (announce = false) => {
        const regionButton = regionButtons[activeRegion];
        angleButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.a5ResidenceAngleButton === activeAngle)));
        regionButtons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.a5ResidenceButton) === activeRegion)));
        stageButtons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.a5ResidenceStageButton) === activeStage)));
        if (residenceLabel) residenceLabel.textContent = regionButton.dataset.a5ResidenceName;
        if (residenceStageLabel) residenceStageLabel.textContent = stageNames[activeStage];
        if (residenceMediaAngle) residenceMediaAngle.textContent = angleName();
        if (residenceMediaRegion) residenceMediaRegion.textContent = regionButton.dataset.a5ResidenceName;
        if (residenceMediaStage) residenceMediaStage.textContent = stageNames[activeStage];
        if (residenceDescription) residenceDescription.textContent = regionButton.dataset.a5ResidenceCopy;
        section.dataset.a5ResidenceActiveAngle = activeAngle;
        section.dataset.a5ResidenceActiveRegion = String(activeRegion);
        section.dataset.a5ResidenceActiveStage = String(activeStage);
        section.dataset.a5ResidenceProgress = lastProgress.toFixed(4);
        if (announce && residenceLive) residenceLive.textContent = `${angleName()}、${regionButton.dataset.a5ResidenceName}、${stageNames[activeStage]}を表示しました`;
      };

      const showExact = (angle, region, stage, announce = false) => {
        activeAngle = angle === 'right' ? 'right' : 'front';
        activeRegion = Math.max(0, Math.min(3, Number(region) || 0));
        activeStage = Math.max(0, Math.min(5, Number(stage) || 0));
        const target = findFrame(activeAngle, activeRegion, activeStage);
        if (!target) return;
        window.gsap.set(frames, { autoAlpha: 0 });
        frames.forEach((frame) => frame.classList.toggle('is-static-selected', frame === target));
        window.gsap.set(target, { autoAlpha: 1 });
        updateCopy(announce);
      };

      const sceneAtProgress = (progress) => {
        const time = Math.max(0, Math.min(1, Number(progress) || 0)) * sequenceDuration;
        const segment = segments.find((item) => time <= item.end) || segments[segments.length - 1];
        if (segment.type === 'hold') return { lower: segment.stage, upper: segment.stage, mix: 0, stage: segment.stage };
        const mix = Math.max(0, Math.min(1, (time - segment.start) / transitionDuration));
        return { lower: segment.from, upper: segment.to, mix, stage: mix < 0.5 ? segment.from : segment.to };
      };

      const renderProgress = (progress) => {
        lastProgress = Math.max(0, Math.min(1, Number(progress) || 0));
        const scene = sceneAtProgress(lastProgress);
        const currentFrames = selectedFrames(activeAngle, activeRegion);
        const lowerFrame = findFrame(activeAngle, activeRegion, scene.lower);
        const upperFrame = findFrame(activeAngle, activeRegion, scene.upper);
        window.gsap.set(frames.filter((frame) => !currentFrames.includes(frame)), { autoAlpha: 0 });
        window.gsap.set(currentFrames, { autoAlpha: 0 });
        if (lowerFrame) window.gsap.set(lowerFrame, { autoAlpha: 1 });
        if (upperFrame && scene.upper !== scene.lower) window.gsap.set(upperFrame, { autoAlpha: scene.mix });
        activeStage = scene.stage;
        frames.forEach((frame) => frame.classList.toggle('is-static-selected', frame === findFrame(activeAngle, activeRegion, activeStage)));
        updateCopy();
      };

      angleButtons.forEach((button) => {
        const handler = () => {
          activeAngle = button.dataset.a5ResidenceAngleButton === 'right' ? 'right' : 'front';
          if (timeline && section.dataset.residenceMotion === 'parallax') renderProgress(renderState.progress);
          else showExact(activeAngle, activeRegion, activeStage);
          if (residenceLive) residenceLive.textContent = `${angleName()}、${regionButtons[activeRegion].dataset.a5ResidenceName}、${stageNames[activeStage]}を表示しました`;
        };
        button.addEventListener('click', handler);
        removers.push(() => button.removeEventListener('click', handler));
      });

      regionButtons.forEach((button) => {
        const handler = () => {
          activeRegion = Number(button.dataset.a5ResidenceButton);
          if (timeline && section.dataset.residenceMotion === 'parallax') renderProgress(renderState.progress);
          else showExact(activeAngle, activeRegion, activeStage);
          if (residenceLive) residenceLive.textContent = `${angleName()}、${button.dataset.a5ResidenceName}、${stageNames[activeStage]}を表示しました`;
        };
        button.addEventListener('click', handler);
        removers.push(() => button.removeEventListener('click', handler));
      });

      stageButtons.forEach((button) => {
        const handler = () => {
          const requested = Math.max(0, Math.min(5, Number(button.dataset.a5ResidenceStageButton) || 0));
          if (trigger && timeline && section.dataset.residenceMotion === 'parallax') {
            const progress = stageStops[requested];
            const destination = trigger.start + (trigger.end - trigger.start) * progress;
            window.scrollTo({ top: destination, behavior: 'auto' });
            timeline.progress(progress);
            if (residenceLive) residenceLive.textContent = `${angleName()}、${regionButtons[activeRegion].dataset.a5ResidenceName}、${stageNames[requested]}を表示しました`;
          } else showExact(activeAngle, activeRegion, requested, true);
        };
        button.addEventListener('click', handler);
        removers.push(() => button.removeEventListener('click', handler));
      });

      residenceMM = window.gsap.matchMedia();
      residenceMM.add('(prefers-reduced-motion: reduce), (min-width: 900px) and (max-height: 640px)', () => {
        section.dataset.residenceMotion = 'static';
        setResidenceActive(false);
        showExact('front', 0, 0);
      });
      const mountResidenceParallax = (mobile) => {
        section.dataset.residenceMotion = 'parallax';
        window.gsap.set(frames, { autoAlpha: 0 });
        window.gsap.set(findFrame(activeAngle, activeRegion, activeStage), { autoAlpha: 1 });
        const usable = Math.max(480, window.visualViewport?.height || window.innerHeight);
        const distance = mobile ? Math.round(usable * 3.6) : Math.min(2200, usable * 2.2);
        renderState.progress = lastProgress;
        timeline = window.gsap.timeline({ paused: true }).to(renderState, {
          progress: 1,
          duration: 1,
          ease: 'none',
          onUpdate() { renderProgress(renderState.progress); }
        });
        trigger = window.ScrollTrigger.create({
          id: `a5-residence-${root.dataset.sectionId}`,
          trigger: mobile ? media : pin,
          start: () => `top top+=${pinTop}`,
          end: `+=${distance}`,
          pin: mobile ? media : pin,
          pinSpacing: true,
          scrub: mobile ? 0.9 : 0.35,
          animation: timeline,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onToggle(self) { if (!mobile) setResidenceActive(self.isActive); },
          onRefresh(self) { section.dataset.a5ResidenceDistance = String(Math.round(self.end - self.start)); }
        });
        section._a5ResidenceTrigger = trigger;
        return () => {
          setResidenceActive(false);
          trigger?.kill();
          trigger = null;
          timeline?.kill();
          timeline = null;
          section._a5ResidenceTrigger = null;
        };
      };
      residenceMM.add('(prefers-reduced-motion: no-preference) and (max-width: 899px)', () => mountResidenceParallax(true));
      residenceMM.add('(prefers-reduced-motion: no-preference) and (min-height: 641px) and (min-width: 900px)', () => mountResidenceParallax(false));
      return () => { setResidenceActive(false); residenceObserver?.disconnect(); residenceObserver = null; removers.forEach((remove) => remove()); residenceMM?.revert(); };
    }

    function setLightActive(active) {
      document.documentElement.classList.toggle('a5-white-light-active', Boolean(active));
    }

    const lightHoldDuration = 0.62;
    const lightTransitionDuration = 0.82;
    const lightSegments = [];
    const lightStageStops = [];
    let lightSequenceDuration = 0;
    for (let stage = 0; stage < 6; stage += 1) {
      const holdStart = lightSequenceDuration;
      const holdEnd = holdStart + lightHoldDuration;
      lightSegments.push({ type: 'hold', stage, start: holdStart, end: holdEnd });
      lightStageStops.push((holdStart + holdEnd) / 2);
      lightSequenceDuration = holdEnd;
      if (stage < 5) {
        lightSegments.push({ type: 'transition', from: stage, to: stage + 1, start: lightSequenceDuration, end: lightSequenceDuration + lightTransitionDuration });
        lightSequenceDuration += lightTransitionDuration;
      }
    }
    lightStageStops.forEach((value, index) => { lightStageStops[index] = value / lightSequenceDuration; });

    function lightSceneAtProgress(progress) {
      const time = Math.max(0, Math.min(1, Number(progress) || 0)) * lightSequenceDuration;
      const segment = lightSegments.find((item) => time <= item.end) || lightSegments[lightSegments.length - 1];
      if (segment.type === 'hold') return { lower: segment.stage, upper: segment.stage, mix: 0, stage: segment.stage };
      const mix = Math.max(0, Math.min(1, (time - segment.start) / lightTransitionDuration));
      return { lower: segment.from, upper: segment.to, mix, stage: mix < 0.5 ? segment.from : segment.to };
    }

    function renderLightProgress(progress) {
      const scene = lightSceneAtProgress(progress);
      const lower = images.find((image) => Number(image.dataset.a5Frame) === scene.lower);
      const upper = images.find((image) => Number(image.dataset.a5Frame) === scene.upper);
      window.gsap.set(images, { autoAlpha: 0 });
      if (lower) window.gsap.set(lower, { autoAlpha: 1 });
      if (upper && scene.upper !== scene.lower) window.gsap.set(upper, { autoAlpha: scene.mix });
      if (scene.stage !== current) selectStage(scene.stage);
    }

    function selectStage(index, announce = false, forceDirect = false) {
      const requested = Math.max(0, Math.min(5, Number(index) || 0));
      const target = images.find((image) => Number(image.dataset.a5Frame) === requested);
      if (!target) return;
      current = requested;
      const directVisibility = forceDirect
        || images.length !== 6
        || window.matchMedia('(prefers-reduced-motion: reduce)').matches
        || window.matchMedia('(min-width: 900px) and (max-height: 640px)').matches;
      images.forEach((image) => {
        const selected = Number(image.dataset.a5Frame) === requested;
        image.classList.toggle('is-static-selected', selected);
        if (window.gsap && directVisibility) {
          window.gsap.set(image, { autoAlpha: selected ? 1 : 0 });
        } else if (!window.gsap) {
          image.style.opacity = selected ? '1' : '0';
          image.style.visibility = selected ? 'visible' : 'hidden';
        }
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.a5Stage) === requested)));
      if (label) label.textContent = stageNames[requested] || stageNames[0];
      if (description) description.textContent = buttons[requested]?.dataset.a5Copy || '';
      if (lightMediaStage) lightMediaStage.textContent = stageNames[requested] || stageNames[0];
      if (announce && live) live.textContent = `${stageNames[requested]}を表示しました`;
    }

    function scrollToStage(index) {
      const trigger = light._a5Trigger;
      if (!trigger || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        selectStage(index, true, true);
        return;
      }
      const progress = lightStageStops[index];
      const destination = trigger.start + (trigger.end - trigger.start) * progress;
      window.scrollTo({ top: destination, behavior: 'auto' });
      light._a5Timeline?.progress(progress);
      if (live) live.textContent = `${stageNames[index]}を表示しました`;
    }

    buttons.forEach((button) => button.addEventListener('click', () => scrollToStage(Number(button.dataset.a5Stage))));
    selectStage(images.some((image) => image.dataset.a5Frame === '0') ? 0 : Number(images[0].dataset.a5Frame));

    const boot = () => {
      if (!window.gsap || !window.ScrollTrigger) {
        window.setTimeout(boot, 80);
        return;
      }
      window.gsap.registerPlugin(window.ScrollTrigger);
      mm = window.gsap.matchMedia();

      if (images.length !== 6) {
        root.dataset.motion = 'static';
        selectStage(images.some((image) => image.dataset.a5Frame === '1') ? 1 : Number(images[0].dataset.a5Frame));
        residenceCleanup = mountResidence();
        window.ScrollTrigger.sort();
        window.ScrollTrigger.refresh();
        return;
      }

      root.dataset.motion = 'multi-parallax';
      mm.add('(prefers-reduced-motion: reduce), (min-width: 900px) and (max-height: 640px)', () => {
        selectStage(1);
        setLightActive(false);
      });

      const mountLightParallax = (mobile) => {
        const gsap = window.gsap;
        gsap.set(images, { autoAlpha: 0 });
        gsap.set(images[0], { autoAlpha: 1 });
        const supportingTweens = [];
        const heroImage = root.querySelector('.a5-white__hero img');
        const shape = root.querySelector('.a5-white__shape');
        const shapeCards = gsap.utils.toArray(root.querySelectorAll('.a5-white__shape-card'));
        const detailImage = root.querySelector('.a5-white__detail img');
        const pinPanel = light.querySelector('.a5-white__light-pin');
        const stageMotion = root.querySelector('[data-a5-stage-motion]');

        if (heroImage) supportingTweens.push(gsap.fromTo(heroImage, { yPercent: -4, scale: 1.07 }, { yPercent: 4, scale: 1.07, ease: 'none', scrollTrigger: { trigger: root.querySelector('.a5-white__intro'), start: 'top bottom', end: 'bottom top', scrub: 0.5 } }));
        shapeCards.forEach((card, index) => supportingTweens.push(gsap.fromTo(card, { yPercent: index % 2 === 0 ? 5 : -3 }, { yPercent: index % 2 === 0 ? -5 : 3, ease: 'none', scrollTrigger: { trigger: shape, start: 'top bottom', end: 'bottom top', scrub: 0.6 } })));
        if (detailImage) supportingTweens.push(gsap.fromTo(detailImage, { yPercent: -3, scale: 1.06 }, { yPercent: 3, scale: 1.02, ease: 'none', scrollTrigger: { trigger: root.querySelector('.a5-white__specs'), start: 'top bottom', end: 'bottom top', scrub: 0.6 } }));

        const usable = Math.max(480, window.visualViewport?.height || window.innerHeight);
        const distance = mobile ? Math.round(usable * 3.6) : Math.min(2200, usable * 2.2);
        const renderState = { progress: 0 };
        const timeline = gsap.timeline({ paused: true }).to(renderState, {
          progress: 1,
          duration: 1,
          ease: 'none',
          onUpdate() { renderLightProgress(renderState.progress); }
        });
        light._a5Timeline = timeline;
        gsap.set(root.querySelectorAll('.a5-white__light-image'), { yPercent: 0, scale: 1 });
        if (!mobile && stageMotion) timeline.fromTo(stageMotion, { y: 4 }, { y: -4, duration: 1, ease: 'none' }, 0);
        light._a5Trigger = window.ScrollTrigger.create({
          trigger: mobile ? light.querySelector('.a5-white__light-media') : pinPanel,
          start: () => `top top+=${pinTop}`,
          end: `+=${distance}`,
          pin: mobile ? light.querySelector('.a5-white__light-media') : pinPanel,
          pinSpacing: true,
          scrub: mobile ? 0.9 : 0.35,
          animation: timeline,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onRefresh(self) { light.dataset.a5LightDistance = String(Math.round(self.end - self.start)); }
        });
        return () => {
          setLightActive(false);
          light._a5Trigger?.kill();
          light._a5Trigger = null;
          light._a5Timeline = null;
          timeline.kill();
          supportingTweens.forEach((tween) => { tween.scrollTrigger?.kill(); tween.kill(); });
        };
      };
      mm.add('(prefers-reduced-motion: no-preference) and (max-width: 899px)', () => mountLightParallax(true));
      mm.add('(prefers-reduced-motion: no-preference) and (min-height: 641px) and (min-width: 900px)', () => mountLightParallax(false));
      residenceCleanup = mountResidence();
      window.ScrollTrigger.sort();
      window.ScrollTrigger.refresh();
    };
    boot();

    const onOrientationChange = () => {
      window.setTimeout(() => {
        applyPinTop();
        window.ScrollTrigger?.refresh();
      }, 120);
    };
    window.addEventListener('orientationchange', onOrientationChange, { passive: true });

    lightObserver = new IntersectionObserver((entries) => {
      setLightActive(entries.some((entry) => entry.isIntersecting));
    }, { threshold: 0.05 });
    lightObserver.observe(light);

    if (sticky) {
      const introButton = root.querySelector('.a5-white__intro .a5-white__button');
      const finalButton = root.querySelector('.a5-white__heritage .a5-white__button');
      observer = new IntersectionObserver(() => {
        const introPassed = introButton && introButton.getBoundingClientRect().bottom < 0;
        const finalVisible = finalButton && finalButton.getBoundingClientRect().top < window.innerHeight;
        sticky.classList.toggle('is-visible', Boolean(introPassed && !finalVisible));
      });
      if (introButton) observer.observe(introButton);
      if (finalButton) observer.observe(finalButton);
    }

    cleanups.set(root, () => { setLightActive(false); residenceCleanup(); observer?.disconnect(); lightObserver?.disconnect(); mm?.revert(); window.removeEventListener('orientationchange', onOrientationChange); cleanups.delete(root); });
  }

  function unmount(root) { cleanups.get(root)?.(); }
  function mountAll(scope = document) { scope.querySelectorAll(SELECTOR).forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll());
  else mountAll();
  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll(SELECTOR).forEach(unmount));
})();
